module.exports = __webpack_public_path__ + "img/high-level-overview.9527903b.jpeg";